
export default {
  props: {
    text: {
      type: String,
      required: '下载'
    },
    disabled: {
      type: Boolean,
      required: false
    }
  }
};